import React from 'react';
import PageHero from '../components/layout/PageHero';
import { ToolGuideCta } from '../components/layout/GuideLayout';
import RollingResistanceCalculator from '../components/tools/RollingResistanceCalculator';

const RollingResistanceCalculatorPage = () => {
  return (
    <div className="min-h-screen" data-testid="rolling-resistance-calculator-page">
      <PageHero
        eyebrow="Engineering Utilities / Vehicle Dynamics"
        title="Rolling Resistance Force Calculator"
        description="Calculate the rolling resistance force between the tyres and the road, and the power and energy needed to overcome it, from vehicle mass, tyre class, road surface, gradient and speed."
        backTo="/tools"
        backLabel="Back to Tools"
        testId="rolling-resistance-calculator-hero"
      />
      <section className="py-12 md:py-16">
        <div className="max-w-screen-2xl mx-auto px-4 md:px-8">
          <RollingResistanceCalculator />
          <ToolGuideCta guidePath="/tools/rolling-resistance-calculator/guide" toolName="Rolling Resistance Force Calculator" />
        </div>
      </section>
    </div>
  );
};

export default RollingResistanceCalculatorPage;
